export default __webpack_public_path__ + "static/me-0c03b01f0a036dd1e720645682dbe50c.svg";